import IconMapSmall from 'assets/icons/pin-map-fill-small.svg';
import { DetailProperty } from 'domain/entities/PropertyEntity';
import moment from 'moment';
import { StreetView } from 'presentation/components/StreetView';
import { PRIVATE_ROUTES } from 'presentation/router/CONSTANTS';
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { COMMON } from 'utilities/constants/COMMON';
import { DATE_FORMAT } from 'utilities/constants/DATE';
import { MapInfo } from '../../CU-057-01/models/MapInfo';

interface props {
    data?: DetailProperty;
}

export const Detail = ({ data }: props) => {
    const [center, setCenter] = React.useState({ lat: 0, lng: 0 });
    const navigate = useNavigate();

    useEffect(() => {
        if (data?.lat && data?.lng) {
            setCenter({ lat: data.lat, lng: data.lng });
        }
    }, [data]);

    const openGoogleMap = (lat?: number, lng?: number) => {
        const mapInfo: MapInfo = {
            lat: lat ?? 0,
            lng: lng ?? 0,
            currentPage: window.location.href,
            address: data?.residence ?? '',
            propertyName: data?.propertyName ?? '',
        };

        navigate(`${PRIVATE_ROUTES.PATH}/${PRIVATE_ROUTES.SUB.CU_057_01}`, {
            state: mapInfo,
        });
    };

    return (
        <section className="detail-right" style={{ width: 343 }}>
            <div className="title-detail">物件概要</div>
            <div className="item-detail-first" style={{ display: 'flex' }}>
                <div className="label-detail">所在地</div>
                <div className="content-detail">
                    {data?.residence ? data.residence : COMMON.EMPTY}
                </div>
                <div
                    className="icon-map-detail"
                    onClick={() => openGoogleMap(data?.lat, data?.lng)}
                >
                    <img src={IconMapSmall} />
                </div>
            </div>
            <div className="item-detail-img" style={{ marginBottom: '10px' }}>
                <StreetView
                    containerStyle={{
                        width: '343px',
                        height: '160px',
                    }}
                    center={center}
                />
            </div>
            <div style={{fontSize:12}}className="content-detail might-overflow whitespace-break-spaces">右上のアイコンをクリックし、拡大してご覧ください。</div>
            <div className="item-detail" style={{ display: 'flex' }}>
                <div className="label-detail">交通</div>
                <div className="content-detail might-overflow whitespace-break-spaces">
                    {!data?.lineName && !data?.stationName && !data?.footMin
                        ? COMMON.EMPTY
                        : `${data?.lineName ? data?.lineName + '  ' : ''}${
                              data?.stationName ? data?.stationName + '駅' : ''
                          }  徒歩 ${data?.footMin ? data?.footMin : '-'}分`}
                </div>
            </div>
            <div className="item-detail" style={{ display: 'flex' }}>
                <div className="label-detail">建物階数</div>
                <div className="content-detail">
                    {/* NOTE: 'floors'は文字列で「階」を含む */}
                    {data?.floors ? data.floors : COMMON.EMPTY}
                </div>
            </div>

            <div className="item-detail" style={{ display: 'flex' }}>
                <div className="label-detail">築年月</div>
                <div className="content-detail">
                    {moment(data?.builtAt, true).isValid()
                        ? moment(data?.builtAt).format(DATE_FORMAT.FORMAT3)
                        : COMMON.EMPTY}
                </div>
            </div>
            <div className="item-detail" style={{ display: 'flex' }}>
                <div className="label-detail">構造</div>
                <div className="content-detail">
                    {data?.structureName ? data.structureName : COMMON.EMPTY}
                </div>
            </div>
            <div className="item-detail" style={{ display: 'flex' }}>
                <div className="label-detail">総戸数</div>
                <div className="content-detail">
                    {data?.numOfUnit ? `${data.numOfUnit}戸` : COMMON.EMPTY}
                </div>
            </div>
            <div className="item-detail" style={{ display: 'flex' }}>
                <div className="label-detail">建物管理会社</div>
                <div className="content-detail">
                    {data?.realEstateMgmtCompany ? data.realEstateMgmtCompany : COMMON.EMPTY}
                </div>
            </div>
        </section>
    );
};
